export const locationTags = [
  {title: 'Home'},
  {title: 'Work'},
  {title: 'Other'},
];
